/* eslint-disable no-shadow,no-underscore-dangle */
import {
  SURVEY_SELECT, SURVEY_ADD, POSSIBLE_SURVEY_GET,
  POSSIBLE_SURVEY_SET, ATTACHMENTS_LIST_GET, ATTACHMENT_SET,
  CLEAR_ATTACHEMNTS_LIST, ATTACHMENT_DELETE, VISIT_SURVEYS_GET,
  SURVEY_DELETE, SET_PROGRESS, SET_READONLY_MODE, CLEAR_SURVEYS_LIST,
  SHOW_ONLY_FILLED_SET, SET_CLOSED_VISIT
} from './action-modulation.type';
import SurveyService from '../services/survey.service';
import VisitService from '../services/visit.service';

export const state = {
  selectedSurvey: null,
  surveysList: [],
  attachmentsList: [],
  possibleSurveys: [],
  readonlyMode: true,
  showOnlyFilled: false,
  closedVisit: false,
};

export const actions = {
  [ATTACHMENT_DELETE](context, params) {
    return VisitService.deleteAttachment(params[0], params[1])
      .then(() => {
        context.commit(ATTACHMENT_DELETE, params[1]);
      })
      .catch((error) => {
        throw new Error(error);
      });
  },
  [ATTACHMENT_SET](context, attachemnt) {
    return context.commit(ATTACHMENT_SET, attachemnt);
  },
  [ATTACHMENTS_LIST_GET](context, visitId) {
    context.commit(CLEAR_ATTACHEMNTS_LIST);
    return VisitService.getAttachemntsList(visitId)
      .then(({ data }) => {
        data.forEach(d => context.commit(ATTACHMENT_SET, d));
      })
      .catch((error) => {
        throw new Error(error);
      });
  },
  [SURVEY_SELECT](context, survey) {
    return context.commit(SURVEY_SELECT, survey);
  },
  [VISIT_SURVEYS_GET](context, visitId) {
    context.commit(CLEAR_SURVEYS_LIST);
    return SurveyService.getVisitSurveys(visitId)
      .then(({ data }) => {
        data.forms.forEach((d) => {
          context.commit(SURVEY_ADD, d);
        });
        context.commit(SET_CLOSED_VISIT, data.closed);
      })
      .catch(error => error);
  },
  [POSSIBLE_SURVEY_GET](context, visitId) {
    return SurveyService.getVisitPossibleSurveys(visitId)
      .then(({ data }) => {
        data.forEach(d => context.commit(POSSIBLE_SURVEY_SET, d));
      })
      .catch((error) => {
        throw new Error(error);
      });
  },
  [SET_READONLY_MODE](context, flag) {
    return context.commit(SET_READONLY_MODE, flag);
  },
  [SURVEY_ADD](context, params) {
    context.commit(SET_PROGRESS, true);
    return SurveyService.addSuveryToVisit(params[0], params[1].map(el => el.id))
      .then((data) => {
        data.data.forEach((survey) => {
          context.commit(SURVEY_ADD, survey);
        });
      })
      .catch((error) => {
        throw new Error(error);
      })
      .finally(() => {
        context.commit(SET_PROGRESS, false);
      });
  },
  [SURVEY_DELETE](context, params) {
    return SurveyService.deleteSuveryFromVisit(params[0], params[1])
      .then(() => {
        context.commit(SURVEY_DELETE, params[1]);
      })
      .catch((error) => {
        throw new Error(error);
      });
  },
  [SHOW_ONLY_FILLED_SET](context, survey) {
    return context.commit(SHOW_ONLY_FILLED_SET, survey);
  },
};

/* eslint no-param-reassign: ["error", { "props": false }] */
export const mutations = {
  [SURVEY_SELECT](state, survey) {
    state.selectedSurvey = survey;
  },

  [SURVEY_ADD](state, survey) {
    state.surveysList.push(survey);
  },
  [SURVEY_DELETE](state, surveyId) {
    state.surveysList = state.surveysList.filter(d => d.id !== surveyId);
  },
  [POSSIBLE_SURVEY_SET](state, survey) {
    state.possibleSurveys.push(survey);
  },
  [ATTACHMENT_SET](state, attachment) {
    state.attachmentsList.push(attachment);
  },
  [ATTACHMENT_DELETE](state, attachmentId) {
    state.attachmentsList = state.attachmentsList.filter(attachment => attachment.id
        !== attachmentId);
  },
  [CLEAR_ATTACHEMNTS_LIST](state) {
    state.attachmentsList = [];
  },
  [CLEAR_SURVEYS_LIST](state) {
    state.surveysList = [];
  },
  [SET_READONLY_MODE](state, flag) {
    state.readonlyMode = flag;
  },
  [SET_CLOSED_VISIT](state, closed) {
    state.closedVisit = closed;
  },
  [SHOW_ONLY_FILLED_SET](state, isShow) {
    state.showOnlyFilled = isShow;
  },
};

export default {
  state,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/visit.module.js